/**
 * Item thumbnails come from the shared `assets/items/` directory, bundled into the admin build so the
 * admin site needs no other host. Each URL is keyed by item id: the file name without `.webp`.
 * Back layers (`<id>.back.webp`) are not thumbnails and are skipped.
 */
const files = import.meta.glob('../../assets/items/*.webp', { eager: true, query: '?url', import: 'default' }) as Record<string, string>;

const byId = new Map<string, string>();
for (const [path, url] of Object.entries(files)) {
  const stem = path.slice(path.lastIndexOf('/') + 1, -'.webp'.length);
  if (!stem.endsWith('.back')) byId.set(stem, url);
}

/** The bundled image URL for an item, or null when the item has no art. */
export function itemThumbUrl(itemId: string | undefined): string | null {
  return itemId ? (byId.get(itemId) ?? null) : null;
}
